export default __webpack_public_path__ + "static/media/mh-bedroom-2nd-01.cdc60edc.jpg";